// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.2.1",
  date: "2026-07-02T07:29:59.961Z",
  gitInfo: {
    dirty: false,
    raw: "b3662af17",
    hash: "b3662af17",
    distance: null,
    tag: null,
    semver: null,
    suffix: "b3662af17",
    semverString: null
  }
};
/* tslint:enable */
